import React, { useEffect, useState } from "react";
import { Container, FormGroup, Label, Input, Modal, ModalHeader, ModalBody } from "reactstrap";
import { Loading } from "../../share/loading";
import { Formik, Field, Form, ErrorMessage } from "formik";
// import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import "../../share/form.css";
import Swal from "sweetalert2";
import CreateTableComponent from "../../share/CreateTableComponent";
import { v4 as uuidv4 } from "uuid";
import { BsPlusLg } from "react-icons/bs";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import TextErrors from "../../share/TextErrors";
import { RenderCustomHeader } from "../../share/RenderCustomHeader";
import { ConvertDateToThaiBuddhist } from "../../share/ConvertDateToThaiBuddhist";
import { ConvertDateFormat } from "../../share/ConvertDateFormat";


export function ProposedToTheSubCommittee4FormComponent() {
 
  // const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dataForSelect, setDataForSelect] = useState([]);
  console.log(dataForSelect)
  const [selectData, setSelectData] = useState([]);
  // console.log("datadetail => ", detailSelectLawOccupation)

  const [openModalForm, setOpenModalForm] = useState(false);
  const modalToggle = () => setOpenModalForm(!openModalForm);

  useEffect(() => {
    async function GetBorrowByType() {
      setLoading(true)
      try {
        const res = await fetch("/api/ProposalBorrow/getInfoBorrowByTestType")
        const data = await res.json()
        setDataForSelect(data.dataenum);
        // console.log(data.dataenum);
      } catch (e) {
        console.log("e => " + e)
      } finally {
        setLoading(false)
      }
    }
    GetBorrowByType()
  }, [])

  


  // parent Form
  const initialValues = {
    meetingNo: "1",
    meetingDate: "",
    meetingYear: "",
    selectDataAr: selectData,
  }

  const validateSchema = Yup.object().shape({
    meetingNo: Yup.number().typeError("กรุณากรอกตัวเลข").required("กรุณากรอกครั้งที่ประชุม"),
    meetingDate: Yup.date().typeError("รูปแบบไม่ถูกต้อง").min(new Date(), "วันที่ประชุมต้องไม่น้อยกว่าวันที่ปัจจุบัน").required("กรุณาเลือกวันที่ประชุม"),
    meetingYear: Yup.string().required("กรุณาเลือกปีที่ประชุม"),
    selectDataAr: Yup.array().min(1, "กรุณาเลือกรายชื่อผู้ขอกู้ยืมเงินอย่างน้อย 1 รายการ"),
  })

  const onSubmit = async (values, action) => {
    setLoading(true)
    // values.meetingNo = values.meetingNo.replace("/","-")
    console.log("valuesparent", values)

    let postData = new FormData();

    Object.entries(values).forEach(([key, value]) => {

      if (key.slice(-2) === "Ar") {
        postData.append(key, JSON.stringify(value));
      } else {
        postData.append(key, value);
      }
    });
    try {
      let res = await fetch("api/ProposalBorrow/saveProposalBorrow4", {
        method: "POST",
        body: postData,
      })
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      let resJson = await res.json();
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      if (resJson.status === 1) {
        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลสำเร็จ",
          confirmButtonColor: "#0A66C2",
          confirmButtonText: "ตกลง",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        })
        // window.location.reload();
      } else {
        Swal.fire({
          icon: "errors",
          title: `${resJson.message}`,
          text: "มีบางอย่างผิดปกติ",
        })

      }

    } catch (e) {
      console.log("err =>", e)

    } finally {
      setLoading(false)
    }
  }

  // child 1 Form

  const selectDataInitialValues = {
    id: "",
    borrowId: "",
    employee: "",
    checkDuplicateValue: ""
  }

  const selectDataValidateSchema = Yup.object().shape({
    borrowId: Yup.string().required("กรุณาเลือก"),
    // lawOccupationId:Yup.string().required("กรุณาเลือก")
  })

  const selectDataOnsubmit = async (values, { setFieldValue, setFieldError, setFieldTouched }, actions) => {
    if (values.borrowId === "--กรุณาเลือก--") {
      setFieldError("borrowId", "กรุณาเลือก")
      setFieldTouched && setFieldError('borrowId', true);
      return;
    } else {
      let match;
      selectData.map((item) => (
        match = item.hasOwnProperty('borrowId') && item.borrowId === Number(values.borrowId)
      ))

      if (match) {
        setFieldError("checkDuplicateValue", "รายชื่อผู้ขอกู้นี้ได้ถูกเลือกไปแล้ว")
        setFieldTouched && setFieldError('borrowId', true);
        // setFieldTouched && setFieldError('trainClassId', true);
      } else {
        let getEmployee;
        getEmployee = dataForSelect.find(({ borrowId }) => borrowId === Number(values.borrowId))

        if (values.id !== "") {
          setSelectData((old) =>
            old.map((row) => {
              if (row.id === values.id) {
                return {
                  ...values,
                  id: values.id,
                };
              }
              return row;
            })
          );
          modalToggle();
        } else {
          // console.log("valuesOnsubmit",values)
          let pre = {
            ...values,
            employee: getEmployee.employee,
            borrowId: getEmployee.borrowId,
            id: uuidv4()
          }
          // console.log(pre);
          setSelectData((prev) => [...prev, pre]);
          modalToggle();
        }
      }
    }

  }




  function OnDelete(row) {
    console.log(row.borrowId)
    setSelectData((current) =>
      current.filter((obj) => {
        return obj.id !== row.id;
      }));

  }


  const COLUMNS = [
    {
      Header: "ลำดับ",
      accessor: (_row, i) => i + 1,
    },
    {
      Header: "ผู้ขอกู้ยืมเงิน",
      accessor: "employee",
    },
    {
      Header: "รายละเอียด",
      accessor: "borrowId",
      Cell: ({ row, value }) => {
        return (
          <div className="text-center">

            <button
              type="button"
              className="btn border border-1 mx-1"
              onClick={() =>
                OnDelete(row.original)
              }
            >
              ลบ
            </button>


          </div>
        );
      },
    },
  ];

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validateSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({ values, handleChange, handleBlur, setFieldValue, setValues, errors, touched }) => {
        // console.log(errors)
        // console.log(values)
        return (
          <Container className="d-flex flex-column justify-content-center align-items-center mb-5">
            {!loading ? (
              <div className="form-border">
                <Form className="p-5 mb-4">

                  <FormGroup>
                    <Label className="mx-1">ครั้งที่ประชุม</Label>
                    <ErrorMessage name="meetingNo" component={TextErrors} />
                    <Field name="meetingNo">
                      {({ field, meta }) => (
                        <Input
                          type="text"
                          id="meetingNo"
                          // disabled={true}
                          className={meta.touched && meta.error ?
                            "input-error rounded-pill text-center input-color" :
                            "rounded-pill text-center input-color"
                          }
                          {...field}
                        />
                      )}
                    </Field>
                  </FormGroup>
                  <FormGroup>
                    <Label className="mx-1">วันที่ประชุม</Label>
                    <ErrorMessage name="meetingDate" component={TextErrors} />
                    <Field name="meetingDate">
                      {({ field, meta, form }) => {
                        return (
                          <DatePicker
                            selected={field.value ? new Date(field.value) : null}
                            locale="th-buddhist"
                            calendarClassName="thai-buddhist"
                            dateFormat="dd MMMM yyyy"
                            value={ConvertDateToThaiBuddhist(field.value)}
                            isClearable={true}
                            placeholderText="กรุณาเลือก"
                            renderCustomHeader={RenderCustomHeader}
                            onChange={(date) => {
                              form.setFieldValue(field.name,ConvertDateFormat(date))
                            }}
                            customInput={
                              <Input
                                type="text"
                                className={
                                  touched.meetingDate && errors.meetingDate
                                    ? "input-error rounded-pill text-center input-color custom-placeholder"
                                    : "rounded-pill text-center input-color custom-placeholder"
                                }
                                value={ConvertDateToThaiBuddhist(field.value)}
                                onChange={() => { }}
                                onBlur={field.onBlur}
                              />
                            }
                          />
                        )
                      }}
                    </Field>
                  </FormGroup>
                  <FormGroup>
                    <Label className="mx-1">ปีที่ประชุม</Label>
                    <ErrorMessage name="meetingYear" component={TextErrors} />
                    <Field name="meetingYear">
                      {({ field, meta }) => (
                        <Input
                          type="select"
                          className={meta.touched && meta.error ?
                            "input-error rounded-pill text-center input-color" :
                            "rounded-pill text-center input-color"
                          }
                          {...field}
                        >
                          <option defaultValue={"กรุณาเลือกปี"}>กรุณาเลือกปี</option>
                          {/* <option value="2565">2565</option> */}
                          <option value="2566">2566</option>
                          <option value="2567">2567</option>
                          <option value="2568">2568</option>
                        </Input>
                      )}
                    </Field>
                  </FormGroup>

                  {/* แบบฟอร์มชั้นที่ 1 เลือก borrowId */}
                  <ErrorMessage name="selectDataAr" component={TextErrors} />
                  <Formik
                    initialValues={selectDataInitialValues}
                    validationSchema={selectDataValidateSchema}
                    onSubmit={selectDataOnsubmit}
                    enableReinitialize
                  >{({ values, handleChange, handleBlur, setFieldValue, setValues, errors, touched }) => {


                    const onAddCourseDetail = () => {
                      setFieldValue("borrowId", "")
                      modalToggle();
                    };

                    const AddDetailCourseBtn = () => {
                      return (
                        <button
                          className="btn border border-1 text-white btn-green"
                          onClick={() => onAddCourseDetail()}
                        >
                          <BsPlusLg className="mx-2" />
                          เลือกรายการ
                        </button>
                      );
                    };

                    return (
                      <>
                        <div className="mt-4"></div>
                        <CreateTableComponent
                          column={COLUMNS}
                          dataInput={selectData}
                          FormInput={AddDetailCourseBtn}
                          showEntrie={false}
                          showPage={false}
                        />

                        <Modal
                          isOpen={openModalForm}
                          toggle={modalToggle}
                          style={{ maxWidth: "600px", width: "100%" }}
                          className="modal-bordered"
                          centered
                          backdrop={"static"}
                          keyboard={false}
                        >
                          <ModalHeader className="styled-modal text-center" toggle={modalToggle}>
                            เลือกรายการ
                          </ModalHeader>
                          <ModalBody className="form-border">
                            <div>
                              <Form autoComplete="off">
                                <div className="p-4">
                                  <FormGroup>
                                    <div className="w-100">

                                      <Label>รายชื่อผู้ขอกู้ยืมเงิน</Label>
                                      {touched.borrowId && errors.borrowId ? (
                                        <span className="text-left text-danger px-1">
                                          {errors.borrowId}
                                        </span>
                                      ) : null}
                                      <ErrorMessage name="checkDuplicateValue" component={TextErrors} />

                                      <Field
                                        name="employee"
                                        style={{ display: "none" }}
                                      />
                                      {/* <Field name="lawOccupationName"/> */}

                                      <Field name="borrowId">
                                        {({ field, meta }) => (
                                          <Input
                                            type="select"
                                            className={meta.touched && meta.error ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                            {...field}

                                          >
                                            <option defaultValue={"--กรุณาเลือก--"}>
                                              --กรุณาเลือก--
                                            </option>
                                            {dataForSelect.map((borrow, i) => (
                                              <option
                                                key={i}
                                                value={borrow.borrowId}
                                              >
                                                {borrow.employee}
                                              </option>
                                            ))}
                                          </Input>
                                        )}
                                      </Field>
                                    </div>
                                  </FormGroup>

                                  <div className="d-flex justify-content-center align-items-center">
                                    <button
                                      type="submit"
                                      disabled={!values.borrowId || values.borrowId === "--กรุณาเลือก--"}
                                      className="btn-blue w-50 mt-2"
                                    >
                                      ยืนยัน
                                    </button>

                                  </div>
                                </div>
                              </Form>
                            </div>
                          </ModalBody>
                        </Modal>

                      </>
                    )
                  }}
                  </Formik>

                  <FormGroup className="d-flex justify-content-center align-items-center">
                    <button type="submit" className="btn-blue w-25">ยืนยัน</button>
                  </FormGroup>
                </Form>

              </div>

            ) : <Loading />}

          </Container>
        )
      }}
    </Formik>

  )

}